import React, { useEffect, useRef, useState } from "react";
import { Modal, Select as AntSelect, Input, Button as AntButton, Tooltip } from "antd";
import { RotateCwIcon, PlusIcon } from "lucide-react";

import {
  add_material_data,
  bp_add_location_data,
  add_machine_room,
  bp_add_parameter_data,
  bp_machine_cat_data,
  save_machine_category,
  bp_add_machine_cat_data,
  bp_add_unit_data,
  bp_units_data,
  save_sub_machine,
  add_Tags,
  add_role,
  add_material_category,
  bp_get_material_category,
} from '@/utils/api';
import { toast } from "react-toastify";
import DcsConfig from "./DcsConfig";
import { useSelector } from "react-redux";
import { defaultColors } from '@/themes/antd-theme';
import useAppSetting from '@/hooks/useAppSetting';

const ConfigModal = ({
  show_modal,
  set_show_modal,
  add_number,
  set_add_number,
  get_status,
  set_get_status,
}) => {
  const selectedModule = useSelector((state) => state.moduleView);
  const isKittingEnabled = useAppSetting('Kitting Enable');
  const [validityError, setValidityError] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddCategory, setIsAddCategory] = useState(false);
  const ipRegex =
    /^(?=\d+\.\d+\.\d+\.\d+$)(?:(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\.?){4}$/;
  const handleCancel = () => {
    setIsModalOpen(false);
    set_show_modal(false);
    reset_function();
    setValidityError('');
  };

  useEffect(() => {
    setIsModalOpen(show_modal);
    bp_get_material_category_data();
  }, [show_modal]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (add_number === 1 && isKittingEnabled) {
      if (!material_validity || material_validity === '') {
        setValidityError('Validity (Days) is required');
        return;
      }
      if (isNaN(material_validity) || Number(material_validity) < 0) {
        setValidityError('Validity must be a valid positive number');
        return;
      }
      setValidityError('');
    }
    add_number === 1 &&
      add_Material({
        material_name: material_name,
        material_unique_id: material_unique_id,
        validity: material_validity,
        module_type: selectedModule,
        category: material_category,
      });
    add_number === 2 && add_unit({ unit_name: unit_name });
    add_number === 3 && add_location({ location_name: location });
    add_number === 4 &&
      add_Parameter({
        parameter_name: paramter_name,
        unit_id: unit_id,
      });
    add_number === 5 && add_machineType({ machine_category_name: machineType, machine_group_ids: [] });
    add_number === 6 &&
      add_machine_location({ room_name: location, room_ip: room_ip });
    add_number === 7 && add_machine_category({ name: machineCategory });
    add_number === 9 && addTags({ name: tagName });
    add_number === 10 && add_subMachine({ name: subMachine });
    add_number === 11 && addRole({ role_name: roleName });
  };

  const success_add_function = (res) => {
    if (res?.status === "failed") {
      toast.warning(res.message);
    } else {
      set_show_modal(false);
      reset_function();
      set_get_status(!get_status);
      toast.success(res.message);
    }
  };

  const reset_function = () => {
    setmaterial_name("");
    setmaterial_unique_id("");
    set_material_category();
    set_unit_name("");
    set_machineCategory("");
    set_loctation("");
    set_room_ip("");
    set_material_validiity("");
    set_paramter_name("");
    setMachineType("");
    setSubMachine("");
    setTagName("");
    setRoleName("");
    set_unit_id("");
    set_material_category("");
  };

  const [unit_list, set_unit_list] = useState([]);
  const get_all_parameters_and_units = async () => {
    try {
      await bp_units_data(success_unit_list_get);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const success_unit_list_get = (res) => {
    set_unit_list(res?.data?.data);
  };

  useEffect(() => {
    add_number === 4 && get_all_parameters_and_units();
  }, [add_number]);

  // ======================================Material===============================

  const [material_name, setmaterial_name] = useState("");
  const [material_cat_list, set_material_cat_list] = useState([]);
  const [material_category_name, set_material_category_name] = useState("");
  const [material_category, set_material_category] = useState();
  const [tagName, setTagName] = useState("");
  const [material_unique_id, setmaterial_unique_id] = useState("");
  const [material_validity, set_material_validiity] = useState("");
  const add_Material = async (materialData) => {
    try {
      await add_material_data(materialData, success_add_function);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleAddCategoryOk = () => {
    if (material_category_name.trim() !== "") {
      add_materialCategory(material_category_name);
    }
  };

  const add_materialCategory = async (category) => {
    try {
      await add_material_category({ category: category }, (res) => {
        if (res?.status === "failed") {
          toast.warning(res.message);
        } else {
          toast.success(res.message);
          bp_get_material_category_data();
          setIsAddCategory(false);
          set_material_category_name("");
        }
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const bp_get_material_category_data = async (category) => {
    try {
      await bp_get_material_category((res) => {
        if (res?.data?.status === "failed") {
          toast.warning(res.message);
          set_material_cat_list([]);
        } else {
          set_material_cat_list(res?.data?.data);
        }
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // ======================================UNit===============================

  const [unit_name, set_unit_name] = useState("");
  const add_unit = async (unitReq) => {
    try {
      await bp_add_unit_data(unitReq, success_add_function);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //   =================================Location========================================
  const [location, set_loctation] = useState("");
  const add_location = async (locationReq) => {
    try {
      await bp_add_location_data(locationReq, success_add_function);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  //   =================================Sub Machine========================================
  const [subMachine, setSubMachine] = useState("");
  const add_subMachine = async (req) => {
    try {
      await save_sub_machine(req, success_add_function);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //   =================================Role Name========================================
  const [roleName, setRoleName] = useState("");
  const addRole = async (roleData) => {
    try {
      await add_role(roleData, success_add_function);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //   ================================= Machine Location========================================
  const [room_ip, set_room_ip] = useState("");

  const add_machine_location = async (locationReq) => {
    if (locationReq?.room_name && locationReq?.room_ip) {
      const validateIpAddress = ipRegex.test(locationReq?.room_ip); // validate ip address
      if (validateIpAddress) {
        try {
          await add_machine_room(locationReq, success_add_function);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      } else {
        toast?.warning("Please Provide Valid IP Address");
      }
    } else {
      toast?.warning("Please provide all the fields");
    }
  };

  //   ================================= Machine Category========================================
  const [machineCategory, set_machineCategory] = useState("");

  const add_machine_category = async (catReq) => {
    if (catReq?.name) {
      try {
        await save_machine_category(catReq, success_add_function);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      toast?.warning("Please provide category name");
    }
  };

  //   =================================Machine Type========================================
  const [machineType, setMachineType] = useState("");

  const add_machineType = async (typeReq) => {
    try {
      await bp_add_machine_cat_data(typeReq, success_add_function);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //   ================================= Add Tags========================================

  const addTags = async (typeReq) => {
    try {
      await add_Tags(typeReq, success_add_function);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //   =================================Parameter========================================
  const [paramter_name, set_paramter_name] = useState("");
  const [unit_id, set_unit_id] = useState("");

  const add_Parameter = async (parameterReq) => {
    try {
      if (parameterReq?.unit_id && parameterReq?.parameter_name) {
        await bp_add_parameter_data(parameterReq, success_add_function);
      } else {
        toast.warning("Please provide all the fields");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const generateUniqueNumber = () => {
    const letters = String.fromCharCode(
      Math.floor(Math.random() * 26) + 65,
      Math.floor(Math.random() * 26) + 65
    );
    const number = Math.floor(100000 + Math.random() * 900000);
    return `${letters}${number}`;
  };

  useEffect(() => {
    if (add_number === 1) setmaterial_unique_id(generateUniqueNumber());
  }, [add_number]);

  return (
    <div>
      <Modal
        title={`Add ${
          add_number === 1
            ? "Material"
            : add_number === 2
            ? "Unit"
            : add_number === 3
            ? "Location"
            : add_number === 4
            ? " New Parameter"
            : add_number === 5
            ? "MachineType"
            : add_number === 6
            ? "Machine Location"
            : add_number === 7
            ? "Machine Category"
            : add_number === 8
            ? "Dcs"
            : add_number === 9
            ? "Dcs Tags"
            : add_number === 10
            ? "Sub Machine"
            : add_number === 11
            ? "Role Name"
            : add_number === 12 && "Material Category"
        }`}
        open={isModalOpen}
        destroyOnHidden
        width={add_number === 8 ? 900 : 480}
        onCancel={handleCancel}
        footer={[]}
        zIndex={2500}
      >
        {add_number === 1 && (
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12">
                <div className="flex flex-col gap-2">
                  <label htmlFor="title" className="font-medium mb-1">Material Name</label>
                  <Input
                    id="title"
                    type="text"
                    size="large"
                    name="title"
                    placeholder="Enter Material Name"
                    value={material_name}
                    required
                    onChange={(e) => setmaterial_name(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-span-12">
                <div className="flex flex-col gap-2">
                  <label htmlFor="title" className="font-medium mb-1">Material Id</label>
                  <div className="flex gap-2 items-center">
                    <Input
                      id="title"
                      type="text"
                      size="large"
                      name="title"
                      placeholder="Enter Unique Material Id"
                      value={material_unique_id}
                      required
                      onChange={(e) => setmaterial_unique_id(e.target.value)}
                    />
                    <Tooltip title="Generate Material Unique Id">
                      <AntButton
                        type="text"
                        size="large"
                        icon={<RotateCwIcon size={20} />}
                        onClick={() => {
                          setmaterial_unique_id(generateUniqueNumber());
                        }}
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>
              {isKittingEnabled && (
                <div className="col-span-12">
                  <div className="flex flex-col gap-2">
                    <label htmlFor="title" className="font-medium mb-1">
                      Validity(Days) <span style={{ color: 'red' }}>*</span>
                    </label>
                    <Input
                      id="title"
                      type="number"
                      size="large"
                      name="title"
                      placeholder="validity"
                      min={0}
                      value={material_validity}
                      status={validityError ? 'error' : ''}
                      onChange={(e) => {
                        set_material_validiity(e.target.value);
                        if (validityError) setValidityError('');
                      }}
                    />
                    {validityError && (
                      <span style={{ color: 'red', fontSize: 12 }}>{validityError}</span>
                    )}
                  </div>
                </div>
              )}
              <div className="col-span-12">
                <div className="flex justify-end gap-4">
                  <AntButton
                    size="large"
                    type="primary"
                    onClick={() => {
                      reset_function();
                    }}
                  >
                    Reset
                  </AntButton>
                  <AntButton
                    size="large"
                    type="primary"
                    htmlType="submit"
                  >
                    Submit
                  </AntButton>
                </div>
              </div>
            </div>
          </form>
        )}
        {add_number === 2 && (
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12">
                <div className="flex flex-col gap-2">
                  <label htmlFor="title" className="font-medium mb-1">Unit Name</label>
                  <Input
                    id="title"
                    type="text"
                    size="large"
                    name="email"
                    placeholder="Enter unit"
                    value={unit_name}
                    required
                    onChange={(e) => set_unit_name(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-span-12">
                <div className="flex justify-end gap-4">
                  <AntButton
                    size="large"
                    type="primary"
                    onClick={() => {
                      reset_function();
                    }}
                  >
                    Reset
                  </AntButton>
                  <AntButton
                    size="large"
                    type="primary"
                    htmlType="submit"
                  >
                    Submit
                  </AntButton>
                </div>
              </div>
            </div>
          </form>
        )}
        {add_number === 3 && (
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12">
                <div className="flex flex-col gap-2">
                  <label htmlFor="title" className="font-medium mb-1">Location</label>
                  <Input
                    id="title"
                    size="large"
                    type="text"
                    name="email"
                    placeholder="Enter Location"
                    value={location}
                    required
                    onChange={(e) => set_loctation(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-span-12">
                <div className="flex justify-end gap-4">
                  <AntButton
                    size="large"
                    type="primary"
                    onClick={() => {
                      reset_function();
                    }}
                  >
                    Reset
                  </AntButton>
                  <AntButton
                    size="large"
                    type="primary"
                    htmlType="submit"
                  >
                    Submit
                  </AntButton>
                </div>
              </div>
            </div>
          </form>
        )}
        {add_number === 4 && (
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12">
                <div className="flex flex-col gap-2">
                  <label htmlFor="title" className="font-medium mb-1">Parameter Name</label>
                  <Input
                    id="title"
                    type="text"
                    size="large"
                    name="email"
                    placeholder="Enter Parameter Name"
                    value={paramter_name}
                    required
                    onChange={(e) => set_paramter_name(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-span-12">
                <div className="flex flex-col gap-2">
                  <label htmlFor="title" className="font-medium mb-1">Unit</label>
                  <div className="flex gap-2 items-center">
                    <AntSelect
                      allowClear
                      showSearch
                      id="demo-select-small"
                      value={unit_id || null}
                      size="large"
                      required
                      style={{
                        width: "100%",
                        borderRadius: "3px",
                      }}
                      bordered
                      placeholder="Select Unit"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        optionA.children.localeCompare(optionB.children)
                      }
                      dropdownStyle={{
                        maxHeight: 400,
                        overflow: "auto",
                      }}
                      onChange={(value, option) => {
                        set_unit_id(value);
                      }}
                    >
                      {unit_list?.map((item) => (
                        <AntSelect.Option key={item.id} value={item.id}>
                          {item.unit_name}
                        </AntSelect.Option>
                      ))}
                    </AntSelect>

                    <Tooltip title="Add Unit">
                      <AntButton
                        type="text"
                        size="large"
                        icon={<PlusIcon size={20} />}
                        onClick={() => {
                          set_show_modal(true);
                          set_add_number(2);
                        }}
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>
              <div className="col-span-12">
                <div className="flex justify-end gap-4">
                  <AntButton
                    size="large"
                    type="primary"
                    onClick={() => {
                      reset_function();
                    }}
                  >
                    Reset
                  </AntButton>
                  <AntButton
                    size="large"
                    type="primary"
                    htmlType="submit"
                  >
                    Submit
                  </AntButton>
                </div>
              </div>
            </div>
          </form>
        )}
        {add_number === 5 && (
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12">
                <div className="flex flex-col gap-2">
                  <label htmlFor="title" className="font-medium mb-1">Machine Type</label>
                  <Input
                    id="title"
                    size="large"
                    type="text"
                    name="email"
                    placeholder="Enter Type"
                    value={machineType}
                    required
                    onChange={(e) => setMachineType(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-span-12">
                <div className="flex justify-end gap-2">
                  <AntButton
                    size="large"
                    type="primary"
                    onClick={() => {
                      reset_function();
                    }}
                  >
                    Reset
                  </AntButton>
                  <AntButton
                    size="large"
                    type="primary"
                    htmlType="submit"
                  >
                    Submit
                  </AntButton>
                </div>
              </div>
            </div>
          </form>
        )}
        {add_number === 6 && (
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12">
                <div className="flex flex-col gap-2">
                  <label htmlFor="title" className="font-medium mb-1">Location</label>
                  <Input
                    id="title"
                    size="large"
                    type="text"
                    name="email"
                    placeholder="Enter Location"
                    value={location}
                    required
                    onChange={(e) => set_loctation(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-span-12">
                <div className="flex flex-col gap-2">
                  <label htmlFor="title" className="font-medium mb-1">IP Address</label>
                  <Input
                    id="title"
                    size="large"
                    type="text"
                    name="email"
                    placeholder="Enter Ip Address"
                    value={room_ip}
                    required
                    onChange={(e) => set_room_ip(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-span-12">
                <div className="flex justify-end gap-4">
                  <AntButton
                    size="large"
                    type="primary"
                    onClick={() => {
                      reset_function();
                    }}
                  >
                    Reset
                  </AntButton>
                  <AntButton
                    size="large"
                    type="primary"
                    htmlType="submit"
                  >
                    Submit
                  </AntButton>
                </div>
              </div>
            </div>
          </form>
        )}
        {add_number === 7 && (
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12">
                <div className="flex flex-col gap-2">
                  <label htmlFor="title" className="font-medium mb-1">Category</label>
                  <Input
                    id="title"
                    size="large"
                    type="text"
                    name="email"
                    placeholder="Enter Category Name"
                    value={machineCategory}
                    required
                    onChange={(e) => set_machineCategory(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-span-12">
                <div className="flex justify-end gap-4">
                  <AntButton
                    size="large"
                    type="primary"
                    onClick={() => {
                      reset_function();
                    }}
                  >
                    Reset
                  </AntButton>
                  <AntButton
                    size="large"
                    type="primary"
                    htmlType="submit"
                  >
                    Submit
                  </AntButton>
                </div>
              </div>
            </div>
          </form>
        )}
        {add_number === 8 && (
          <DcsConfig
            show_table={true}
            addForm={true}
            set_get_status={set_get_status}
            get_status={get_status}
          />
        )}

        {add_number === 9 && (
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12">
                <div className="flex flex-col gap-2">
                  <label htmlFor="title" className="font-medium mb-1">Tags</label>
                  <Input
                    id="title"
                    size="large"
                    type="text"
                    name="email"
                    placeholder="Enter Tag Name"
                    value={tagName}
                    required
                    onChange={(e) => setTagName(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-span-12">
                <div className="flex justify-end gap-4">
                  <AntButton
                    size="large"
                    type="primary"
                    onClick={() => {
                      reset_function();
                    }}
                  >
                    Reset
                  </AntButton>
                  <AntButton
                    size="large"
                    type="primary"
                    htmlType="submit"
                  >
                    Submit
                  </AntButton>
                </div>
              </div>
            </div>
          </form>
        )}

        {add_number === 10 && (
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12">
                <div className="flex flex-col gap-2">
                  <label htmlFor="title" className="font-medium mb-1">Sub Machine</label>
                  <Input
                    id="title"
                    size="large"
                    type="text"
                    name="email"
                    placeholder="Enter machine name"
                    value={subMachine}
                    required
                    onChange={(e) => setSubMachine(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-span-12">
                <div className="flex justify-end gap-4">
                  <AntButton
                    size="large"
                    type="primary"
                    onClick={() => {
                      reset_function();
                    }}
                  >
                    Reset
                  </AntButton>
                  <AntButton
                    size="large"
                    type="primary"
                    htmlType="submit"
                  >
                    Submit
                  </AntButton>
                </div>
              </div>
            </div>
          </form>
        )}
        {add_number === 11 && (
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12">
                <div className="flex flex-col gap-2">
                  <label htmlFor="title" className="font-medium mb-1">Role Name</label>
                  <Input
                    id="title"
                    size="large"
                    type="text"
                    name="email"
                    placeholder="Enter Role name"
                    value={roleName}
                    required
                    onChange={(e) => setRoleName(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-span-12">
                <div className="flex justify-end gap-4">
                  <AntButton
                    size="large"
                    type="primary"
                    onClick={() => {
                      reset_function();
                    }}
                  >
                    Reset
                  </AntButton>
                  <AntButton
                    size="large"
                    type="primary"
                    htmlType="submit"
                  >
                    Submit
                  </AntButton>
                </div>
              </div>
            </div>
          </form>
        )}
      </Modal>
      <Modal
        title={"Add Material Category"}
        open={isAddCategory}
        onCancel={() => {
          setIsAddCategory(false);
          set_material_category_name("");
        }}
        onOk={handleAddCategoryOk}
        okText="Add"
        okButtonProps={{
          disabled: !material_category_name,
        }}
        zIndex={2500}
        destroyOnHidden
        width={480}
      >
        <Input
          type="text"
          size="large"
          placeholder="Material Category Name"
          value={material_category_name}
          onChange={(e) => set_material_category_name(e.target.value)}
        />
      </Modal>
    </div>
  );
};
export default ConfigModal;
